import React from "react";
import PropTypes from "prop-types";
//import material-ui components
import withStyles from "@material-ui/core/styles/withStyles"
import IconButton from "@material-ui/core/IconButton";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import { DateTimePicker } from "@material-ui/pickers";
//import material icons
import Close from "@material-ui/icons/Close";
//import core components
import Button from "components/CustomButtons/Button.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import MonoText from "components/Typography/Mono.jsx";
import modalStyle from "assets/jss/material-kit-react/modalStyle.jsx";

class LogsDialog extends React.Component {
    render(){
        const { classes, onClose, isOpened, } = this.props;
        return (
            <Dialog
                classes={{
                    root: classes.center,
                    paper: classes.modal
                }}
                maxWidth={false}
                open={isOpened}
                onClose={onClose}
            >
                <DialogTitle
                    disableTypography
                    className={classes.modalHeader}
                >
                    <IconButton
                        className={classes.modalCloseButton}
                        key="close"
                        aria-label="Close"
                        color="inherit"
                        onClick={onClose}
                    >
                        <Close className={classes.modalClose} />
                    </IconButton>
                    <h4 className={classes.modalTitle} >Логи автомата</h4>
                </DialogTitle>
                <DialogContent className={classes.modalBody}>
                    <DateTimePicker value={this.props.fromTime} onChange={(date) => this.props.changeFromTime(date)}
                                    ampm={false} invalidDateMessage="Неверный формат даты" label="От" className={classes.dateTime}
                                    okLabel="Сохранить" cancelLabel="Отменить" todayLabel="Сегодня" showTodayButton disableFuture
                    />
                    <DateTimePicker value={this.props.toTime} onChange={(date) => this.props.changeToTime(date)}
                                    ampm={false} invalidDateMessage="Неверный формат даты" label="От" className={classes.dateTime}
                                    okLabel="Сохранить" cancelLabel="Отменить" todayLabel="Сегодня" showTodayButton disableFuture
                    />
                    <CustomInput
                        labelText="Количество записей"
                        formControlProps={{
                            className: classes.keySearchInput,
                            fullWidth: false
                        }}
                        inputProps={{
                            value: this.props.limit,
                            onChange: e => this.props.changeLimit(e.target.value)
                        }}
                    />
                    { this.props.data && this.props.data.split("\n").map((i, key) => {
                        return <MonoText key={key}>{i}</MonoText>
                    })}
                </DialogContent>
                <DialogActions>
                    <Button color="primary" simple
                            onClick={onClose}
                    >
                        OK
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }
}

LogsDialog.propTypes = {
    changeFromTime: PropTypes.func,
    changeToTime: PropTypes.func,
    changeLimit: PropTypes.func,
    isOpened: PropTypes.bool,
    data: PropTypes.string,
    onClose: PropTypes.func,
};

export default withStyles(modalStyle)(LogsDialog);


// WEBPACK FOOTER //
// ./src/components/Dialogs/LogsDialog.jsx